import {
  getOrganizationListQueryKey,
  organizationList,
  useOrganizationCreate,
  useOrganizationIpRestrictionGet,
  useOrganizationIpRestrictionUpdate,
  useOrganizationList,
  useOrganizationUpdate,
} from "@/api/generated/endpoints/api"

export const organizationApi = {
  useOrganizationList,
  useOrganizationCreate,
  useOrganizationUpdate,
  useOrganizationIpRestrictionGet,
  useOrganizationIpRestrictionUpdate,
  organizationList,
  getOrganizationListQueryKey,
}
